export const SET_PARAMETERS = 'SET_PARAMETERS';
export const ADD_URL_PARAM = 'ADD_URL_PARAM';
export const REPLACE_URL_PARAM = 'REPLACE_URL_PARAM';
export const SET_REFERENCES = 'SET_REFERENCES';

export const SET_USER_VISIBLE_COLUMNS = 'SET_USER_VISIBLE_COLUMNS';